// removed by extract-text-webpack-plugin
module.exports = {"menu":"_XzlWXGXanps7605jae8R","open":"_3K_sW9muCO14uY_nBXrj99","image":"HGcKvyLLBsEdVJzLFut6N","item":"_1yaXrPZ-V4TSX1hmyMePeI","text":"_3nfKiS6PHuDrTgOIAeH7La","category":"_2eVo5CvOmyyZexFlB9U0J7","content":"_3e-kUQQn-GtlEnh7Gzge-y"};


//////////////////
// WEBPACK FOOTER
// ./src/features/Menu/menu.module.styl
// module id = 74
// module chunks = 79611799117203 210842664985301